import { AiService } from "../models/api/agentStep.model";
import { RuleTag } from "../models/api/governance/violationRule.model";

export function getAiServiceLogoPath(aiService: AiService) {
    switch (aiService) {
        case AiService.m365Copilot:
            return "assets/images/logo/m365Copilot.svg";
        case AiService.copilotStudio:
            return "assets/images/logo/copilotStudio.svg";
        case AiService.chatGptEnterprise:
            return "assets/images/logo/openAI-icon.svg";
        default:
            throw new Error(`getAiServiceLogoPath: platform ${aiService} not supported`);
    }
}

const AI_SERVICE_DISPLAY_NAMES: Partial<Record<AiService, string>> = {
    [AiService.m365Copilot]: "M365 Copilot",
    [AiService.copilotStudio]: "Copilot Studio",
    [AiService.chatGptEnterprise]: "Chat GPT Enterprise",
};

export function getAiServiceDisplayName(aiService: AiService): string {
    const displayName = AI_SERVICE_DISPLAY_NAMES[aiService];
    if (displayName) {
        return displayName;
    }
    throw new Error(`getAiServiceDisplayName: service ${aiService} not supported`);
}

/**
 * Checks if the agent is a Microsoft 365 agent with a custom name (declarative agent)
 */
export function isM365CustomAgent(aiService: AiService, agentDisplayName: string): boolean {
    return aiService === AiService.m365Copilot && agentDisplayName !== "Microsoft365Copilot";
}

export function isAiRule(rule: { tags?: string[]; platform?: string }) {
    return rule.tags?.includes(RuleTag.AIDR) || Object.values(AiService).includes(rule.platform as AiService);
}
